import { generate_guid } from '@/rlMxModules/utils/util'

class rlBeamModelSectData {
  constructor(ID = null, Name = null, Mat = null, Kind = null, ShapeVal = null, Guid = null) {
    // this.ID = ID // 数据库ID
    this.Name = Name //截面名称
    this.Mat = Mat //材质
    this.Kind = Kind //截面类型
    this.ShapeVal = ShapeVal //截面尺寸
    this.Guid = Guid ? Guid : generate_guid()
  }
}

export default rlBeamModelSectData
